import { CalendarClock } from 'lucide-react';

type PaymentReceiptNextProps = {
  title: string;
  description: string;
};

/** A próxima parcela e por onde ela chega. */
export function PaymentReceiptNext({
  title,
  description,
}: PaymentReceiptNextProps) {
  return (
    <section className='flex items-start gap-3 rounded-2xl bg-alba-blue-500/10 px-4 py-3.5'>
      <CalendarClock
        aria-hidden='true'
        className='mt-0.5 h-5 w-5 shrink-0 text-alba-blue-600'
        strokeWidth={1.8}
      />
      <div className='min-w-0'>
        <h2 className='text-sm font-semibold text-alba-black-500'>{title}</h2>
        <p className='mt-1 text-sm leading-relaxed text-alba-gray-600'>
          {description}
        </p>
      </div>
    </section>
  );
}
